import React from 'react';
import Head from 'next/head';
import dynamic from 'next/dynamic';

const ViewMore = dynamic(() => import('../../../components/ViewMore'));

const WeStriveForInovations = props => {
  return (
    <>
      <Head>
        <title>We Strive for Innovations - Prodigi</title>

        <meta
          name="description"
          content="At ProDigi, we believe there is always a space for development and improvement. That is why we have adopted innovation at the heart of entrepreneurship."
        />
        <meta property="og:url" content="https://weprodigi.com/about-us/we-strive-for-inovations" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="We Strive for Innovations - Prodigi" />
        <meta
          property="og:description"
          content="At ProDigi, we believe there is always a space for development and improvement. That is why we have adopted innovation at the heart of entrepreneurship."
        />
        <meta property="og:image" content="https://admin.weprodigi.com/uploads/images/photo_2022-04-29_18-02-49.jpg" />
      </Head>
      <main>
        <style global jsx>{`
          .bg-image {
            background-size: cover;
            background-image: url('/images/about/innovations1.png');
            background-position: center;
          }
          .bg-image-light {
            background-size: cover;
            background-image: url('/images/about/Group3198.png');
            background-position: center;
          }
          @media screen and (max-width: 758px) {
            .bg-image {
              background-image: url('/images/about/innovations1.png');
            }
            .bg-image-light {
              background-image: url('/images/about/Group3206.png');
            }
          }
        `}</style>
        <div className="relative w-full  h-700  overflow-hidden  bg-image">
          <div className="container h-full">
            <h1 className="relative h-full  flex flex-col flex-wrap justify-center items-start ">
              <div className="uppercase text-white text-30 md:text-72 font-black leading-none">We Strive for</div>
              <div className="uppercase text-green text-30 md:text-72 font-black ">Innovations</div>
            </h1>
          </div>
        </div>
        <div className="body-part">
          <div className="bg-white">
            <div className="container py-30">
              At ProDigi, we believe there is always a space for development and improvement. That is why we have adopted innovation at the heart of
              entrepreneurship. Our thoughtful approach to innovation incorporates modern technologies and tools in all the business processes,
              whether creating a new product, developing a new market strategy, or improving team management.
              <p className="mt-20  leading-none">
                Striving for continual innovation and not an instant perfection, we have defined the pillars supporting business performance.
              </p>
            </div>
          </div>

          <div className="bg-gray-light">
            <div className="container py-30">
              <h2 className="titple text-purple text-24 leading-none  font-black uppercase">Product innovation</h2>
              <div className="flex flex-wrap justify-between mt-20">
                <div className="w-full md:w-half-auto">
                  <p className="mb-30 md:mb-0">
                    {' '}
                    Product innovation is creating an entirely new product or service. It is meant to offer a brand new way to solve a problem of
                    consumers, better and more advanced than already existing versions in the market. We take on innovation to improve existing
                    products, add new features to them or launch a new idea. How do we generate new ideas for product innovation? Everything is
                    simple; we prioritize client and customer needs, understand them and develop new solutions while anticipating where the market is
                    heading. One of our product innovations is the development of exclusive branded games, a one-of-a-kind solution in digital
                    marketing for gamification for advertising.{' '}
                  </p>
                </div>
                <div className="w-full md:w-half-auto">
                  <picture className="mt-30 md:mt-0">
                    <source srcSet="/images/about/productin-group_images1.png" type="image/png" />
                    <img src="/images/about/productin-group_images1.png" alt="discover image" width="539" height="303" />
                  </picture>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white">
            <div className="container py-30">
              <h2 className="titple text-purple text-24 leading-none  font-black uppercase">Business model innovation</h2>
              <p className="mt-20 hidden md:block">
                Business model innovation is crucial but should be reasoned by market changes and fluctuations to pursue new opportunities and address
                new challenges. Our business strategy that has proved to be efficient is the business model that our organization leads and values. We
                take on business model innovation to adjust the marketing, pricing, internal and external communication funnels, and more. And every
                new adjustment is meant to bring more value to our clients and scale up a potentially more successful business.
              </p>
              <p className="mt-20 block md:hidden">
                <ViewMore ln={60}>
                  Business model innovation is crucial but should be reasoned by market changes and fluctuations to pursue new opportunities and
                  address new challenges. Our business strategy that has proved to be efficient is the business model that our organization leads and
                  values. We take on business model innovation to adjust the marketing, pricing, internal and external communication funnels, and
                  more. And every new adjustment is meant to bring more value to our clients and scale up a potentially more successful business.
                </ViewMore>
              </p>
            </div>
          </div>
          <div className="bg-gray-light">
            <div className="container py-30">
              <h2 className="titple text-purple mb-25 text-24 leading-none font-black uppercase">Process innovation</h2>
              <div className="flex flex-wrap flex-col-reverse md:flex-row justify-between mt-0 md:mt-30">
                <div className="w-full md:w-half-auto">
                  <picture className=" ">
                    <source srcSet="/images/about/PM-group_images.png" type="image/png" />
                    <img src="/images/about/PM-group_images.png" alt="discover image" width="539" height="202" />
                  </picture>
                </div>
                <div className="w-full md:w-half-auto">
                  <p className=" mb-25 md:mb-0">
                    As an active member of the global digital community, we strive for innovations and keep up with the pace to try, test, and
                    implement new technologies. Process innovation is the strategy to remain competitive and meet our customer demands. It goes in
                    parallel with the business model and product innovation, the mechanism with aligned nuts and bolts that smoothly function as one.
                    Time management and the integration of effective tracking solutions is one way of process management. Evaluating our partners’
                    time, we offer second to none customizable landing page with the features of real-time project tracking.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white">
            <div className="container py-30">
              <h2 className="titple text-purple text-24 leading-none  font-black uppercase">Organizational innovation</h2>
              <p className="mt-20  ">
                To make idea execution and business innovation possible, we first master organizational innovation and face structural challenges all
                armed up. Leveraging innovations and refining the use of the knowledge, we seek and implement new ways to improve our company’s
                organizational structure and make it more flexible for partnership.{' '}
              </p>
            </div>
          </div>
          <div className="bg-gray-light">
            <div className="container py-30">
              <h2 className="titple text-purple text-24 leading-none  font-black uppercase">Environmental innovation</h2>
              <p className="mt-20  ">
                Being fully digital, we have cut possible business processes that may somehow have a negative impact on the environment and planet,
                thus fostering environmental innovation. We call for all organizations and agencies to reduce the effects of production processes on
                the earth, promote a sustainable economy, and work in hand to make our planet a better place for future generations.{' '}
              </p>
            </div>
          </div>
          <div className="bg-white">
            <div className="container py-30">
              <h2 className="titple text-purple text-24 leading-none  font-black uppercase">Social innovation</h2>
              <p className="mt-20  ">
                The final component and value for our company is social innovation, the strategies we go for to develop practical solutions for social
                and environmental issues. As part of the community, local or global, we use knowledge and skills to support social progress and active
                collaboration with the nonprofit world.
              </p>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};
export default WeStriveForInovations;
